import { render, staticRenderFns } from "./ReservationStatus.vue?vue&type=template&id=73880830&scoped=true&"
import script from "./ReservationStatus.vue?vue&type=script&lang=js&"
export * from "./ReservationStatus.vue?vue&type=script&lang=js&"
import style0 from "./ReservationStatus.vue?vue&type=style&index=0&id=73880830&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73880830",
  null
  
)

export default component.exports